const config = {    
    api: 'https://itera.grupobonnard.com:5002',
    request_timeout_api: 650000,
    apiReportes: 'https://itera.grupobonnard.com:8181/reportes_api',
    printLocalService: 'http://localhost:5000',
    detectarInactividadEnSegundos: 60*480
};

module.exports = config;
